export const OPT_IN_PREFERENCE = {
  CLICK_STREAM: 'cs',
  AI: 'ai',
  SEARCH: 'search',
  E_COMMERCE: 'e-commerce',
  ADS: 'ads',
} as const;

export type OptInPreference =
  (typeof OPT_IN_PREFERENCE)[keyof typeof OPT_IN_PREFERENCE];

export const OPT_IN_PREFERENCES: OptInPreference[] =
  Object.values(OPT_IN_PREFERENCE);

// The buckets that move together as one consent topic. Excludes `ai`, which is
// independently grantable, and `cs`, which is the master consent.
export const GROUPED_BUCKETS: OptInPreference[] = [
  OPT_IN_PREFERENCE.SEARCH,
  OPT_IN_PREFERENCE.E_COMMERCE,
  OPT_IN_PREFERENCE.ADS,
];

export const TERMS_UPDATED_CONSENT_BUCKETS: OptInPreference[] = [
  OPT_IN_PREFERENCE.CLICK_STREAM,
  ...GROUPED_BUCKETS,
];
